<template>
    <div>
        <header-portrate />

    <div style="margin-bottom:70px;">
        <bread-crumbs :items="items"></bread-crumbs>
        <tabs-comp :tabs="tabs" />

        <v-row class="mainrow m-2" :style="`direction:`+lang.dir+`;margin-top:100px !important;`">
            <v-col cols="12">
                <h4 style="font-weight:bold">{{ lang.zi_page_title }}</h4>
                <small>{{ lang.zi_page_help }}</small>
            </v-col>

            <v-col cols="12">
                <span v-for="g in groups" :key="g.key" :class="'zi-card ' + (filter.group == g.key ? 'zi-card-on ' : '') + 'zi-card-' + g.key" @click="setGroup(g.key)">
                    <b>{{ g.text }}</b>
                    <span v-if="g.key != ''" class="zi-card-n">{{ counts[g.key] || 0 }}</span>
                </span>
            </v-col>

            <v-col cols="12">
                <v-row>
                    <v-col cols="12" md="2"><b-form-select class="selborder" :options="typeFilter" v-model="filter.doc_type" @change="load(1)" /></v-col>
                    <v-col cols="12" md="2"><b-form-input class="inborder" type="date" v-model="filter.from" @change="load(1)" /></v-col>
                    <v-col cols="12" md="2"><b-form-input class="inborder" type="date" v-model="filter.to" @change="load(1)" /></v-col>
                    <v-col cols="12" md="4"><b-form-input class="inborder" v-model="filter.search" :placeholder="lang.zi_search" @change="load(1)" /></v-col>
                </v-row>

                <table class="table table-bordered table-sm">
                    <thead><tr>
                        <th>{{ lang.zi_date }}</th><th>{{ lang.zi_doc_type }}</th><th>{{ lang.zi_number }}</th><th>{{ lang.zi_customer }}</th>
                        <th>{{ lang.zi_total }}</th><th>{{ lang.zi_status }}</th><th>{{ lang.zi_reason }}</th><th></th>
                    </tr></thead>
                    <tbody>
                        <tr v-for="d in rows" :key="d.id">
                            <td style="white-space:nowrap">{{ (d.inv_date || d.created_at || '').substr(0, 16) }}</td>
                            <td>{{ d.doc_type == 'return' ? lang.zi_return : lang.zi_invoice }}<br><small>{{ d.subtype == 'standard' ? lang.zi_standard : (d.subtype == 'simplified' ? lang.zi_simplified : '') }}</small></td>
                            <td>{{ d.invoice_number }}</td>
                            <td>{{ d.company || d.customer }}<br><small>{{ d.mobile }}</small></td>
                            <td>{{ d.ftotal }}</td>
                            <td><span :class="'zi-badge zi-' + statusKey(d)">{{ statusText(d) }}</span></td>
                            <td style="max-width:420px;font-size:12px">
                                <div v-if="d.problems.length">
                                    <b>{{ lang.zi_erp_check }}:</b>
                                    <div v-for="(p, i) in d.problems" :key="'p' + i">&bull; {{ $zatcaProblemText(p, lang) }}</div>
                                </div>
                                <div v-if="d.errors.length || (d.last_error && !d.problems.length)">
                                    <b>{{ lang.zi_zatca_says }}:</b>
                                    <div v-for="(e, i) in d.errors" :key="'e' + i" dir="ltr">&bull; {{ e }}</div>
                                    <div v-if="!d.errors.length" dir="ltr">{{ d.last_error }}</div>
                                </div>
                                <div v-for="(w, i) in d.warnings" :key="'w' + i" class="zi-text-warn" dir="ltr">{{ w }}</div>
                            </td>
                            <td style="white-space:nowrap">
                                <v-btn x-small v-if="d.fixable" style="background:#0a6ebd;color:#fff" @click="openFix(d)">{{ lang.zi_fix }}</v-btn>
                                <v-btn x-small v-if="d.status == 'pending' || d.status == 'failed'" @click="resend(d)">{{ lang.zi_resend }}</v-btn>
                            </td>
                        </tr>
                        <tr v-if="rows.length == 0"><td colspan="8" class="text-center">-</td></tr>
                    </tbody>
                </table>
                <div class="text-center">
                    <v-btn x-small :disabled="page <= 1" @click="load(page - 1)">{{ lang.zi_prev }}</v-btn>
                    {{ page }} / {{ Math.max(1, Math.ceil(total / size)) }}
                    <v-btn x-small :disabled="page * size >= total" @click="load(page + 1)">{{ lang.zi_next }}</v-btn>
                </div>
            </v-col>
        </v-row>

        <v-dialog v-model="fix.open" max-width="820">
            <v-card v-if="fix.data" :style="`direction:` + lang.dir">
                <v-card-title>{{ lang.zi_fix_title }} &mdash; {{ fix.data.invoice_number }}</v-card-title>
                <v-card-text>
                    <div v-if="fix.data.problems.length" class="zi-alert zi-warn">
                        <b>{{ lang.zi_erp_check }}:</b>
                        <div v-for="(p, i) in fix.data.problems" :key="'fp' + i">&bull; {{ $zatcaProblemText(p, lang) }}</div>
                    </div>
                    <div v-if="fix.data.errors.length || fix.data.last_error" class="zi-alert zi-bad">
                        <b>{{ lang.zi_zatca_says }}:</b>
                        <div v-for="(e, i) in fix.data.errors" :key="'fe' + i" dir="ltr">&bull; {{ e }}</div>
                        <div v-if="!fix.data.errors.length" dir="ltr">{{ fix.data.last_error }}</div>
                    </div>
                    <div v-if="!fix.data.amounts_ok" class="zi-alert zi-bad">{{ lang.zi_amounts_locked }}</div>

                    <h6 class="zi-h">{{ lang.zi_buyer }}</h6>
                    <v-row>
                        <v-col cols="12" md="6" v-for="f in buyerFields" :key="f.key">
                            <label>{{ f.label }}</label>
                            <b-form-input class="inborder" v-model="fix.data.buyer[f.key]" :dir="f.ltr ? 'ltr' : ''" />
                        </v-col>
                    </v-row>

                    <h6 class="zi-h">{{ lang.zi_items }}</h6>
                    <small>{{ lang.zi_amounts_locked }}</small>
                    <table class="table table-bordered table-sm">
                        <tbody>
                            <tr v-for="(item, i) in fix.data.items" :key="item.id">
                                <td style="width:40px">{{ i + 1 }}</td>
                                <td><b-form-input class="inborder" v-model="item.name" /></td>
                                <td style="width:90px">{{ item.qty }}</td>
                                <td style="width:110px">{{ item.total }}</td>
                                <td style="width:90px">{{ item.vat }}</td>
                            </tr>
                        </tbody>
                    </table>

                    <div v-if="fix.result" :class="'zi-alert ' + (['reported','cleared'].indexOf(fix.result.status) > -1 ? 'zi-good' : 'zi-warn')">
                        <b>{{ lang.zi_now }}:</b> {{ lang['zi_st_' + fix.result.status] || fix.result.status }}
                        <div v-for="(p, i) in fix.result.problems" :key="'rp' + i">&bull; {{ $zatcaProblemText(p, lang) }}</div>
                        <div v-for="(e, i) in fix.result.errors" :key="'re' + i" dir="ltr">&bull; {{ e }}</div>
                        <div v-if="!fix.result.errors.length && fix.result.last_error" dir="ltr">{{ fix.result.last_error }}</div>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="fix.open = false">{{ lang.zi_close }}</v-btn>
                    <v-btn style="background:green;color:#fff" :disabled="busy" @click="saveFix">{{ lang.zi_save_resend }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <vue-snotify></vue-snotify>
    </div>
        <Footer />
    </div>
</template>

<script>
import axios from 'axios'
import BreadCrumbs from '@/components/breadCrumbs.vue';
import TabsComp from '@/components/tabsComp.vue';
import HeaderPortrate from '@/components/Header-Portrate.vue';
import Footer from '@/components/Footer.vue';
import {SnotifyPosition} from 'vue-snotify';
export default{
    components: {BreadCrumbs, TabsComp, HeaderPortrate, Footer},
    data() {
        return {
            busy: false,
            rows: [],
            counts: {},
            total: 0,
            page: 1,
            size: 50,
            filter: {group: 'attention', doc_type: '', from: '', to: '', search: ''},
            fix: {open: false, data: null, result: null},
        }
    },
    methods: {
        // index.php type=zatcaInapp (php/includes/zatca/Api.php). Resolves to the result, or null after showing the error.
        call(action, payload){
            const post = new FormData();
            post.append("type", 'zatcaInapp');
            post.append('defBranch', localStorage.getItem('defBranch'));
            post.append('financeYear', localStorage.getItem('financeYear'));
            post.append("auth", this.$cookies.get(this.$COOKIEPhase));
            post.append("data[action]", action);
            post.append("data[payload]", JSON.stringify(payload || {}));
            this.busy = true;
            return axios.post(this.$SAMCOTEC.r_path, post).then((response) => {
                this.busy = false;
                const res = response.data;
                if(!res.error || res.error.number != 200){
                    this.alert(res.error ? res.error.message : 'error');
                    return null;
                }
                return res.results.data;
            }, (error) => {
                this.busy = false;
                this.alert(String(error));
                return null;
            });
        },
        alert(message){
            this.$snotify.error(message, this.lang.alert, {
                timeout: 1000000,
                showProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                position: SnotifyPosition.centerCenter,
                buttons: [{text: this.lang.zi_close, action: (toast) => { this.$snotify.remove(toast.id); }}]
            });
        },
        load(page){
            const payload = Object.assign({page: page}, this.filter);
            this.call('invoices', payload).then((data) => {
                if(!data) return;
                this.rows = data.rows;
                this.counts = data.counts;
                this.total = data.total;
                this.page = data.page;
                this.size = data.size;
            });
        },
        setGroup(key){
            this.filter.group = key;
            this.load(1);
        },
        statusKey(d){
            return d.awaiting_clearance ? 'awaiting_clearance' : d.status;
        },
        statusText(d){
            const key = this.statusKey(d);
            return this.lang['zi_st_' + key] || key;
        },
        resend(d){
            this.call('resend', {id: d.id}).then((data) => {
                if(!data) return;
                this.$snotify.success(this.lang['zi_st_' + data.status] || data.status, '', {timeout: 3000, showProgressBar: false, position: SnotifyPosition.centerTop});
                this.load(this.page);
            });
        },
        openFix(d){
            this.fix.result = null;
            this.call('fix_get', {id: d.id}).then((data) => {
                if(!data) return;
                this.fix.data = data;
                this.fix.open = true;
            });
        },
        saveFix(){
            const d = this.fix.data;
            const items = d.items.map((item) => ({id: item.id, name: item.name}));
            this.call('fix_save', {id: d.id, buyer: d.buyer, items: items}).then((data) => {
                if(!data) return;
                this.fix.result = data;
                this.load(this.page);
                if(['reported', 'cleared', 'pending'].indexOf(data.status) > -1 && data.problems.length == 0){
                    this.$snotify.success(this.lang['zi_st_' + data.status] || data.status, '', {timeout: 3000, showProgressBar: false, position: SnotifyPosition.centerTop});
                }
            });
        },
    },

    created() {
        this.load(1);
    },
    computed: {
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                    return this.$store.state.lang.en;
                }else if(this.$cookies.get(this.$store.state.LangCooki)  == 'ur'){
                    return this.$store.state.lang.ur;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }
            else if(this.$store.state.deflang == 'ur'){
                return this.$store.state.lang.ur;
            }else{
                return this.$store.state.lang.ar;
            }
        },
        groups: function(){
            return [
                {key: 'attention', text: this.lang.zi_grp_attention},
                {key: 'waiting', text: this.lang.zi_grp_waiting},
                {key: 'sent', text: this.lang.zi_grp_sent},
                {key: '', text: this.lang.zi_grp_all},
            ];
        },
        typeFilter: function(){
            return [
                {text: this.lang.zi_all, value: ''},
                {text: this.lang.zi_invoice, value: 'invoice'},
                {text: this.lang.zi_return, value: 'return'},
            ];
        },
        buyerFields: function(){
            return [
                {key: 'name', label: this.lang.zi_buyer_name},
                {key: 'vat', label: this.lang.zi_vat, ltr: true},
                {key: 'crn', label: this.lang.zi_crn, ltr: true},
                {key: 'building_number', label: this.lang.zi_building, ltr: true},
                {key: 'street', label: this.lang.street_name || this.lang.zi_street},
                {key: 'secondary_number', label: this.lang.zi_secondary, ltr: true},
                {key: 'district', label: this.lang.district || this.lang.zi_district},
                {key: 'city', label: this.lang.city || this.lang.zi_city},
                {key: 'postal_code', label: this.lang.zi_postal, ltr: true},
            ];
        },
        items: function() {
            return {
                    text: this.lang.zi_page_title,
                    disabled: true,
                    to: '/zatca-invoices',
                }
        },
        tabs: function() {
            const menu = this.$store.getters['state'].menu;
            const license = this.$store.getters['state'].licenseType.activemenu;
            const alicense = this.$store.getters['state'].licenseType
            let currentMenu = menu[license];
            if(!license){
              return false;
            }
            let cMenu = {main: {},sub:[]};
            Object.values(currentMenu).forEach(value =>{
            const cM = localStorage.getItem('currentMenu');
            if(value.main.index == cM){
                cMenu = value.sub;
            }else if(cM == null && value.main.index == 1){
                cMenu = value.sub;
            }
            });

            let t = []
            Object.values(cMenu).forEach(value =>{

                if(this.$route.path == value.href){
                    value.class = "mytab";
                }else{
                    value.class = "mytab4";
                }
                if(this.lang.langname == 'ar'){
                    value.name = value.arname
                }else{
                    value.name = value.enname
                }
                for(let i =0; i< value.groupid.length;i++){
                    if(value.groupid[i] == this.$store.getters['state'].group_id){
                    if(alicense[value.perms[0]] || value.perms[0] == 'any')
                        t.push(value)
                    }
                }

            })

            return t;
        }
    },
}
</script>

<style scoped>
.zi-h { margin-top: 14px; font-weight: bold; }
.zi-card { display: inline-block; padding: 8px 14px; margin: 0 6px 6px 0; border-radius: 8px; border: 1px solid #ddd; cursor: pointer; background: #fafafa; }
.zi-card-on { border-color: #0a6ebd; box-shadow: 0 0 0 2px #0a6ebd33; }
.zi-card-n { display: inline-block; margin: 0 6px; font-size: 18px; font-weight: bold; }
.zi-card-attention .zi-card-n { color: #c0392b; }
.zi-card-waiting .zi-card-n { color: #0c5460; }
.zi-card-sent .zi-card-n { color: #1e7e34; }
.zi-alert { padding: 8px 12px; border-radius: 6px; margin: 6px 0; }
.zi-bad { background: #fde8e8; color: #9b1c1c; }
.zi-warn { background: #fdf6e3; color: #8a5a00; }
.zi-good { background: #e6f4ea; color: #1e7e34; }
.zi-text-warn { color: #8a5a00; }
.zi-badge { display: inline-block; padding: 2px 8px; border-radius: 10px; font-size: 12px; background: #eee; white-space: nowrap; }
.zi-reported, .zi-cleared { background: #d4edda; color: #155724; }
.zi-imported { background: #e2e3e5; color: #383d41; }
.zi-pending, .zi-awaiting_clearance { background: #d1ecf1; color: #0c5460; }
.zi-failed, .zi-unsigned { background: #fff3cd; color: #856404; }
.zi-rejected, .zi-needs_data { background: #f8d7da; color: #721c24; }
</style>
